import { deserialize } from 'cerialize'
import { ReceivingFileModel } from 'Models'
import { BusinessappsProductModel } from 'Pages/orders_design'

export class BusinessappsOrdersModel {
	@deserialize public id: number
	@deserialize public name: string
	@deserialize public status: string
	@deserialize public attachment: ReceivingFileModel
	@deserialize public description: string
	@deserialize public short_description: string
	@deserialize public available_products: BusinessappsProductModel[]
}
